import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import {
  addCasinoFavorite,
  removeCasinoFavorite,
  useAuthSession,
} from '@/api';
import { queryKeys } from '@/api/query-keys';
import type { CasinoGame } from '@/domain';

export function useCasinoFavorites() {
  const { loggedIn, user } = useAuthSession();
  const queryClient = useQueryClient();
  const machineGuid = user?.Guid?.trim() ?? '';

  const toggleFavorite = useCallback(
    (game: CasinoGame) => {
      if (!loggedIn || !machineGuid) return;
      void (async () => {
        if (game.FavoriteId != null) {
          await removeCasinoFavorite(game.FavoriteId);
        } else {
          await addCasinoFavorite(machineGuid, game.ProviderGameId);
        }
        await queryClient.invalidateQueries({ queryKey: queryKeys.casino.all });
      })();
    },
    [loggedIn, machineGuid, queryClient],
  );

  return {
    showFavorite: loggedIn,
    toggleFavorite,
  };
}
